import { getTheme, IconButton, IIconProps } from '@fluentui/react';
import * as React from 'react';

const { palette } = getTheme();
const copyIcon: IIconProps = { iconName: 'Copy' };

export interface CopyButtonProps {
  text: string;
  className?: string;
}

export class CopyButton extends React.PureComponent<CopyButtonProps, Record<string, unknown>> {
  private inputRef;

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  render(): JSX.Element {
    return (
      <div className={this.props.className}>
        <div className="d-table">
          <span className="d-table-cell align-middle">
            <input
              ref={this.inputRef}
              type="text"
              value={this.props.text}
              className="text-right"
              style={{ border: 0 }}
              size={this.props.text.length}
              readOnly
            />
          </span>
          <span className="d-table-cell align-middle pl-1">
            <IconButton
              iconProps={copyIcon}
              title="Copy"
              ariaLabel="Copy"
              onClick={(): void => this.copyTextToClipboard()}
              styles={{
                rootHovered: {
                  backgroundColor: palette.neutralLighterAlt
                }
              }}
            />
          </span>
        </div>
      </div>
    );
  }

  private copyTextToClipboard(): void {
    this.inputRef.current.select();
    document.execCommand('copy');
  }
}
